<div id="wrapper" class="wrapper clearfix">
  <app-header></app-header>
<section class="blog blog-grid pt-70 pb-90">
  <div class="container pairblank">
    <div class="page__section">
      <nav class="breadcrumb breadcrumb_type5" aria-label="Breadcrumb">
        <ol class="breadcrumb__list r-list">
          <li class="breadcrumb__group">
            <a [routerLink]="['/capital-increase']" title="Sermaye Artırımı"class="breadcrumb__point r-link">Sermaye Artırımı</a>
            <span class="breadcrumb__divider" aria-hidden="true">›</span>
          </li>
          <li class="breadcrumb__group">
            <span class="breadcrumb__point" aria-current="page">{{capitalIncrease?.name}}</span>
          </li>
        </ol>
      </nav>
    </div>
    <div class="row" style="padding: 15px;">
      <div class="col-sm-12 col-md-12 col-lg-8 mb-30-xs mb-30-sm">
        <nav class="accordion arrows">
          <header class="box public-offering-header">
            <h1>{{capitalIncrease?.code?capitalIncrease?.title:capitalIncrease?.name}} <span class="visible-title">Hisse Halka Arz</span></h1>
          </header>
          <div class="row">
            <div class="col" style="font-weight:bold;">Tarih</div>
            <div class="col">Belirtilmemiş</div>
            <div class="w-100"></div>
            <div class="col" style="font-weight:bold;">Tutar</div>
            <div class="col">{{capitalIncrease?.amount}}</div>
            <div class="w-100"></div>
            <div class="col" style="font-weight:bold;">Rüçhan</div>
            <div class="col">{{capitalIncrease?.priority}}</div>
            <div class="w-100"></div>
            <div class="col" style="font-weight:bold;">Yüzde</div>
            <div class="col">{{capitalIncrease?.rate}}</div>
            <div class="w-100"></div>
            <div class="col" style="font-weight:bold;">SPK Onay</div>
            <div class="col">{{capitalIncrease?.spkApproval}}</div>
            <div class="w-100"></div>
          </div>
          <div class="row" *ngFor="let link of linkList ; trackBy: trackByFnLink">
            <div class="col" style="font-weight:bold;"><a class="text-link"
                                                          href="{{link.url}}">{{link.title}}</a></div>
            <div class="w-100"></div>
          </div>
          <app-company [code]="capitalIncrease?.code"></app-company>
        </nav>
        <div class="widget market-pricing market-list card mb-3" style="position: relative; padding:10px; margin-top:50px;">
          <div class="row">
            <div class="col-md-2  p-md-1 ">
              <img loading="lazy" src="{{domainURL}}halka-arz.webp" alt="{{capitalIncrease?.name}} Halka Arz" title="{{capitalIncrease?.name}} Halka Arz"
              >
            </div>
            <div class="col"><strong>{{capitalIncrease?.name}} Halka Arz</strong>, ve daha fazla şirketin halka arz tarihleri için sayfasını ziyaret edebilirsiniz.</div>
            <div class="w-100"></div>
            <br>
            <p>Şirketlerin, hisselerin ve güncel borsa analizlerine <strong><a [routerLink]="['/analysis']" title="Analiz">Analiz </a></strong>sayfamızdan ulaşabilirsiniz.</p>
            <div class="widget market-pricing market-list card mb-3" style="position: relative; padding:10px; margin-top:50px;">
              <app-comment [commentCount]="commentCount"  [title]="title" [rootId]="rootId"></app-comment>
            </div>
            <br>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-md-12 col-lg-4">
        <div class="widget widget-recent-posts">
          <app-draft-month [toYear]="toYear"></app-draft-month>
          <app-draft-dividend [toYear]="toYear"></app-draft-dividend>
          <app-summary-info></app-summary-info>
          <app-summary-analysis [imageStatus]="true" [count]="5"></app-summary-analysis>
        </div>
      </div>
    </div>
    <p class="visible-title"><strong>{{capitalIncrease?.code}} Hisse </strong><strong>{{capitalIncrease?.name}} Hisse </strong><strong>Halka Arz</strong><strong>Halka Arz Tarihleri</strong></p>
  </div>
</section>
<app-footer></app-footer>
<div id="back-to-top" class="backtop"><fa-icon [icon]="faArrUp"></fa-icon></div>
</div>